import React from "react"

import ProjectIconUI5 from "../../../../../../core/gd-ui/project-icon/project-icon-ui5"

export default function newPage_getMyTemplates() {
    const templates = _.chain(gd.session.templatesList.models)
        .filter(t=>t.companyId === gd.companyId && !t.isDeleted && t.isPage)
        .orderBy(t=>t.sortPosition)
        .value()

    const res: any = []

    res.push({
        typeId      : "empty",
        icon        : "ii5-task-list",
        title       : "Empty page",
        description : "Create and organize documents in a flexible hierarchy."
    });

    templates.map(template=>{
        res.push({
            id              : template.id,
            typeId          : "template",
            icon            : template.iconClass,
            iconComponent   : <ProjectIconUI5 className="option-icon" size="16" projectId={template.id} colorize={false}/>,
            title           : template.name,
            description     : template.description ? template.description : "No description"
        })
    })

    return res
}